import React from 'react'
import { Layout, Button } from 'antd'
import Header from './Header'
import ImageBg from '../../../assets/images/bg.jpg'
import styles from './index.scss'
import Particles from 'react-particles-js'
import intl from 'react-intl-universal'
import { ReactTypeformEmbed } from 'react-typeform-embed'
import * as tfE from '@typeform/embed'

interface IS {
    height: number
    width: number
}

class Home extends React.Component<any, IS> {
    state = { height: 0, width: 0 }

    private containerRef: HTMLDivElement = null
    private timer: NodeJS.Timer = null

    private typeformEmbed: any = tfE

    listenResize = () => {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.setSize()
        }, 100)
    }

    setSize = () => {
        if (this.containerRef) {
            const { clientHeight, clientWidth } = this.containerRef
            this.setState({ height: clientHeight, width: clientWidth })
        }
    }

    setRef = (ref: HTMLDivElement) => {
        this.containerRef = ref
        this.setSize()
    }

    bindOrUnbindResize = (type: 'bind' | 'unbind') => {
        const listener = type === 'bind' ? window.addEventListener : window.removeEventListener
        listener('resize', this.listenResize, false)
    }

    componentDidMount() {
        this.bindOrUnbindResize('bind')
    }

    componentWillUnmount() {
        this.bindOrUnbindResize('unbind')
    }


    openForm = () => {
        this.typeformEmbed.typeform.open()
    }

    render() {
        return (
            <Layout style={{ height: '100vh' }}>
                <Header/>
                <div style={{
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                    textAlign: 'left',
                    position: 'relative'
                }}>
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        background: `url(${ImageBg})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        height: '100%',
                        width: '100%'
                    }} src={ImageBg}/>
                    <div className={styles.gradient}/>
                    <Particles
                        style={{
                            zIndex: 2000,
                            width: '100%',
                            height: '100vh',
                            position: 'absolute',
                            top: 0,
                            left: 0
                        }}/>
                    <div className={styles.container_content} style={{ zIndex: 5000 }}>
                        <h1
                            className={styles.title}>{intl.get('HOME_TITLE')}</h1>
                        <h3
                            className={styles.description}
                            style={{ color: '#ccc' }}>{intl.get('HOME_DESCRIPTION')}</h3>
                        <Button onClick={() => {
                            this.openForm()
                        }} style={{ cursor: 'pointer', marginTop: '40px' }}>
                            {intl.get('CONTACT')}
                        </Button>

                    </div>
                </div>

                <div style={{ position: 'relative', zIndex: 200000 }}>
                    <ReactTypeformEmbed
                        popup
                        autoOpen={false}
                        url={intl.get('CONTACT_URL')}
                        hideHeaders
                        hideFooter
                        style={{ position: 'absolute', top: 100, zIndex: 200000 }}
                        buttonText={intl.get('CONTACT')}
                        ref={tf => {
                            this.typeformEmbed = tf
                        }}
                    />
                </div>

            </Layout>
        )
    }
}

export default Home
